import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorNotificationService {
  readonly errorMessage = signal<string | null>(null);
  readonly isErrorClosing = signal(false);
  private closeTimer?: ReturnType<typeof setTimeout>;
  private removeTimer?: ReturnType<typeof setTimeout>;

  showError(message: string): void {
    if (this.errorMessage() === message) {
      return;
    }

    this.clearCloseTimer();
    this.clearRemoveTimer();
    this.isErrorClosing.set(false);
    this.errorMessage.set(message);
    this.closeTimer = setTimeout((): void => {
      this.closeError();
    }, 6500);
  }

  closeError(): void {
    this.clearCloseTimer();
    if (!this.errorMessage() || this.isErrorClosing()) {
      return;
    }

    this.isErrorClosing.set(true);
    this.removeTimer = setTimeout((): void => {
      this.errorMessage.set(null);
      this.isErrorClosing.set(false);
      this.removeTimer = undefined;
    }, 500);
  }

  private clearCloseTimer(): void {
    if (this.closeTimer === undefined) {
      return;
    }

    clearTimeout(this.closeTimer);
    this.closeTimer = undefined;
  }

  private clearRemoveTimer(): void {
    if (this.removeTimer === undefined) {
      return;
    }

    clearTimeout(this.removeTimer);
    this.removeTimer = undefined;
  }
}
